import { Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import countryCodes from '../../../assets/data/countryCode.json';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
`;

const CountryCodeSelect = styled(Select)`
  border-bottom: 1px solid #397ef3;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  width: 34%;
  outline: none;
  box-shadow: none !important;
  font-size: 16px;

  &:focus {
    box-shadow: none !important;
  }
`;

const PhoneNumber = styled(Input)`
  border-bottom: 1px solid #397ef3;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  width: 64%;
  outline: none;
  font-size: 16px;

  &:focus {
    box-shadow: none;
  }
`;

export const InputPhone = ({ onChange, isInvalid }) => {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('+1');

  const handleCodeChange = ({ value }) => setCode(value);
  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  useEffect(() => {
    onChange({
      code,
      phone,
    });
  }, [onChange, phone, code]);

  return (
    <Wrapper>
      <CountryCodeSelect labelInValue defaultValue={code} onChange={handleCodeChange}>
        {countryCodes.map((item, index) => (
          <CountryCodeSelect.Option value={item.dial_code} key={index}>
            {item.dial_code} ({item.code})
          </CountryCodeSelect.Option>
        ))}
      </CountryCodeSelect>
      <PhoneNumber
        value={phone}
        onChange={handlePhoneChange}
        style={{ color: isInvalid ? '#F20606' : '#000' }}
        placeholder="(000) 000 00 00"
      />
    </Wrapper>
  );
};
